import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading procurement data...',
  className,
}) => {
  return (
    <div className={cn('flex h-48 w-full flex-col items-center justify-center gap-3 text-muted-foreground', className)}>
      <Loader2 className="h-7 w-7 animate-spin text-primary" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
};
